import { ErrorModal } from "@/components/shared/modal/error-modal";
import Grid from "@material-ui/core/Grid";
import * as React from "react";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useWorkerTypesContext } from "../workerTypes/context/WorkerTypesContext";
import { getWorkerTypes } from "../workerTypes/repositories/WorkerTypesRepository";
import { TableWorkers } from "./components/WorkersDataTable/TableWorkers.js";
import { useWorkersContext } from "./context/WorkersContext";
import { getWorkers } from "./repositories/WorkersRepository";

export const Workers = () => {
	const { state, actions } = useWorkersContext();
	const { actions: wTypeActions } = useWorkerTypesContext();
	const [isLoading, setIsLoading] = useState(true);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getWorkersFromAPI = async () => {
		setIsLoading(true);
		await Promise.all([getWorkers(), getWorkerTypes()])
			.then((r) => {
				const [workersResp, wTypesResp] = r;

				if (workersResp.ok) {
					actions.setWorkers(workersResp.data?.data);

					wTypeActions.setWorkerTypes(wTypesResp.data?.data);
					setIsLoading(false);
				}
			})
			.catch((e) => {
				setFetchDataError(e);
				setShowErrorModal(true);
			});
	};

	useEffect(() => {
		getWorkersFromAPI();
	}, []);

	if (state.workers) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<div style={{ width: "100%", padding: "10px 0 20px" }}>
							<TableWorkers
								isLoading={isLoading}
								getWorkersFromAPI={getWorkersFromAPI}
							/>
						</div>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
